const nameToImageMap: { [key: string]: string } = {
  "anbarasu": "Anbarasu.png",
  "arulkumar": "ArulKumar.png",
  "dinesh": "Dinesh.png",
  "ehagaya": "ehagaya.png",
  "jaya": "ehagaya.png",
  "gopal": "Gopal.png",
  "joseph": "Joseph.png",
  "kalai": "Kalaiselvan.png",
  "karthick": "Karthick.png",
  "pramod": "PramodVarms.png",
  "rafik": "Rafik.png",
  "rajan": "Rajan.png",
  "riaz khan": "RiazKhan.png",
  "sabir": "Sabir.png",
  "satish": "Satish.png",
  "senthil": "Senthil.png",
  "siddharth": "Siddharthan.png",
  "vijayalakshmi": "Vijayalakshmi.png",
  "bala": "Bala.png"
};

export const getImageSrc = (value: string): string => {
  if (value !== undefined || value !== "") {
    const lowerValue = value.toLowerCase();
    for (const key in nameToImageMap) {
      if (lowerValue.includes(key)) {
        return `/assets/MasteringSigns/${nameToImageMap[key]}`;
      }
    }
  }
  // fallback base64 image
  return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAEklEQVR42mP8z8BQDwAF/gJ+W6Cn5QAAAABJRU5ErkJggg==";
};
